import SuscripcionesService from './SuscripcionesService';

export default SuscripcionesService;